<nav class="shop-locator-navigation-container" [attr.aria-labelledby]="'shop-locator-navigation-title'">
    <h2
        class="sr-only"
        i18n="@@hermes.store_locator.navigation_bar.store_search_by_country_and_city"
        id="shop-locator-navigation-title"
        >Store search by country and city</h2
    >
    <ol class="navigation-bar">
        <li class="find-store-link">
            <button
                i18n="@@page--hermes-global--find-store.find-a-store"
                type="button"
                role="link"
                class="paragraph-xsmall"
                (click)="navigateToFindStore()"
                >Find a store
            </button>
        </li>
        <li #country>
            <h-svg-icon [name]="'arrow-right'"></h-svg-icon>
            <h-shop-locator-navigation-item
                [isActive]="(cityItemMode$ | async) === 'none'"
                [title]="(countryTitle$ | async) ?? ''"
                (click)="openTray('countries', $event)"
                >{{ currentTranslatedCountry$ | async }}
            </h-shop-locator-navigation-item>
        </li>

        @if ((cityItemMode$ | async) !== "none") {
            <li #city>
                <h-svg-icon [name]="'arrow-right'"></h-svg-icon>
                <h-shop-locator-navigation-item
                    [isActive]="(cityItemMode$ | async) === 'button'"
                    [title]="(cityTitle$ | async) ?? ''"
                    (click)="openTray('cities', $event)"
                    >{{ currentTranslatedCity$ | async }}
                </h-shop-locator-navigation-item>
            </li>
        }
    </ol>
</nav>
